import { FaroSelect, Option } from '@faro/design-system';
import { isEqual } from 'lodash';

export interface TimeRangeSelectProps {
    value: string[];
    handleChange: (value?: string[], event?: Event) => void;
    options: Option<string>[];
    wrapSelected?: boolean;
}

export const ENTIRE_STUDY = 'Entire Study';

const TimeRangeSelect = (props: TimeRangeSelectProps): JSX.Element => {
    const { value, handleChange, options, wrapSelected = false } = props;

    const innerHandleChange = (newValue?: string | string[]) => {
        if (!newValue) {
            return;
        }

        let newValueFormatted = typeof newValue === 'string' ? [newValue] : [...newValue];

        // If no value is selected, select the entire study
        if (newValueFormatted.length === 0) {
            newValueFormatted = [ENTIRE_STUDY];
        }

        // if all values are selected, select the entire study and unselect the rest
        else if (newValueFormatted.length === options.length - 1 && !newValueFormatted.includes(ENTIRE_STUDY)) {
            newValueFormatted = [ENTIRE_STUDY];
        }

        // if previous value did not include entire study, and new value includes entire study, unselect the rest
        else if (newValueFormatted.includes(ENTIRE_STUDY) && !value.includes(ENTIRE_STUDY)) {
            newValueFormatted = [ENTIRE_STUDY];
        }

        // if any value is selected, unselect the entire study
        else if (newValueFormatted.length > 1 && newValueFormatted.includes(ENTIRE_STUDY)) {
            newValueFormatted = newValueFormatted.filter(v => v !== ENTIRE_STUDY);
        }

        // if the new value is the same as the old value, do nothing
        if (isEqual(value, newValueFormatted)) {
            return;
        }

        handleChange(newValueFormatted);
    };

    return (
        <FaroSelect
            name="timeRangeSelect"
            appearance="outlined"
            value={value}
            onChange={innerHandleChange}
            options={options}
            multiSelect={true}
            multiSelectWrap={wrapSelected}
            clearable={false}
            fullWidth={true}
        />
    );
};

export { TimeRangeSelect };
